import React, { useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import momentTz from 'moment-timezone';
import styled from 'styled-components';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import FormContext from 'src/presentation/contexts/FormContext';
import { getSelectorOptions } from 'src/presentation/components/pages/shared/utils/Utils';
import { InputSize } from 'src/presentation/components/forms/InputSize';

const TIMEZONES = momentTz.tz.names().map(item => ({ id: item, label: item }));

const TimeZoneSelector = ({ attr, label, description = '' }) => {
  const { workingState } = useContext(FormContext);
  const selected = get(workingState, attr);
  const dropdownOptions = getSelectorOptions(TIMEZONES);

  const selectedDropdownOption: any = find(dropdownOptions, o => o.value === selected) || dropdownOptions[0];

  return (
    <HalfRow>
      <DropdownContainer>
        <Dropdown
          searchable
          attr={attr}
          data-aid={attr}
          label={label}
          description={description}
          options={dropdownOptions}
          text={selectedDropdownOption.label}
          value={selectedDropdownOption.value}
        />
      </DropdownContainer>
    </HalfRow>
  );
};

const HalfRow = styled(CustomRow)`
  width: 50%;
  max-width: 470px;
  min-width: 350px;
`;

const DropdownContainer = styled.div`
  width: ${InputSize.LARGE}px;
`;

export default TimeZoneSelector;
